<template>
    <div id="app">
        <main-background />
        <main-menu />
        <main-social-links />
        <main-page>
            <router-view />
        </main-page>
        <main-footer />
    </div>
</template>

<script>
    import MainBackground from './components/main/MainBackground';
    import MainMenu from './components/main/MainMenu';
    import MainSocialLinks from './components/main/MainSocialLinks';
    import MainPage from './components/main/MainPage';
    import MainFooter from './components/main/MainFooter';

    export default {
        name: 'default',

        components: {
            MainBackground,
            MainMenu,
            MainSocialLinks,
            MainPage,
            MainFooter,
        },
    };
</script>

<style lang="scss">
    html {
        scroll-behavior: smooth;
    }

    body {
        margin: 0;
    }

    #app {
        font-family: $main-font;
        letter-spacing: 0.5px;
    }
</style>
